<template>
<div>
  <form class="form-horizontal" @submit.prevent="submit">
    <fieldset>
      <legend>Edycja notowania</legend>
      <div class="row">
        <div class="col-md-2">
          <input :value="record.card.slug" class="form-control" disabled>
        </div>
        <div class="col-md-10">
          <question-button
                  v-if="!record.product.archived"
                  question="Czy na pewno zarchiwizować produkt?"
                  @click="archiveProduct(record.product)"
                  class="btn btn-danger pull-right"
          >
            <trash-icon></trash-icon>
            Archiwizuj produkt
          </question-button>
          <question-button
                  v-if="record.product.archived"
                  question="Czy na pewno przywrócić produkt?"
                  @click="unArchiveProduct(record.product)"
                  class="btn btn-warning pull-right"
          >
            <trash-icon></trash-icon>
            Przywróć produkt
          </question-button>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>Dane ogólne</legend>
      <div class="row">
        <div class="col-md-6">
          <form-group label="Nazwa" :error="errors['product.name']">
            <text-input v-model="record.product.name"></text-input>
          </form-group>
          
          <form-group label="Odmiana">
            <text-input v-model="record.product.variety"></text-input>
          </form-group>
          
          <form-group :offset-col="2">
            <checkbox-input label="Dostępność" v-model="record.product.enabled"></checkbox-input>
          </form-group>
        </div>
        <div class="col-md-6">
          <form-group label="Pochodzenie" :error="errors['product.origin']">
            <select-input v-model="record.product.origin" :options="originOptions"></select-input>
          </form-group>
          
          <form-group label="Jednostka" :error="errors['product.unit']">
            <text-input v-model="record.product.unit"></text-input>
          </form-group>
        </div>
      </div>
    </fieldset>
    
    <div class="row">
      <div class="col-md-4">
        <fieldset>
          <legend>Aktualne ceny (opublikowane)</legend>
          <form-group v-for="(price, index) in record.publicPrices" :key="index">
            <currency-input v-model="price.price" disabled></currency-input>
          </form-group>
        </fieldset>
      </div>
      <div class="col-md-4">
        <fieldset>
          <legend>Aktualizacja cen (ceny do publkacji)</legend>
          <form-group v-for="(price, index) in record.draftPrices" :key="index">
            <currency-input
              v-model="price.price"
              @keydown.native.plus.prevent="addDraftPrice"
              @keydown.native.minus.prevent="removeFocusedDraftPrice"
              @keydown.native.up.prevent="focusPreviousDraftPrice"
              @keydown.native.down.prevent="focusNextDraftPrice"
              @focus.native="updateFocusedDraftPrice(index)"
              :focused="isDraftPriceFocused(index)"
            ></currency-input>
            <button @click="removeDraftPrice(index)" class="btn btn-danger" slot="addon" type="button">
              <minus-icon></minus-icon>
            </button>
          </form-group>
          
          <button @click="addDraftPrice" type="button" class="btn btn-info">
            <plus-icon></plus-icon>
            Dodaj cenę
          </button>
        </fieldset>
      </div>
      <div class="col-md-4">
        <fieldset>
          <legend>Ceny z poprzedniego notowania</legend>
          <form-group v-for="(price, index) in record.previousPrices" :key="index">
            <currency-input v-model="price.price" disabled></currency-input>
          </form-group>
          
          <p v-if="emptyPreviousPrices">Brak cen z poprzedniego notowania</p>
          <div v-else>
            <question-button
              question="Czy na pewno użyć cen z wczoraj?"
              @click="usePreviousPrices"
              class="btn btn-default"
            >
              <arrow-left-icon></arrow-left-icon>
              Użyj dzisiaj
            </question-button>
          </div>
        </fieldset>
      </div>
    </div>
    
    <hr>
    
    <submit-button :submitting="submitting"></submit-button>
  </form>
</div>
</template>
<script>
import FormGroup from './FormGroup.vue'
import TextInput from './TextInput.vue'
import CurrencyInput from './CurrencyInput.vue'
import CheckboxInput from './CheckboxInput.vue'
import QuestionButton from './QuestionButton.vue'
import TrashIcon from './TrashIcon.vue'
import PlusIcon from './PlusIcon.vue'
import MinusIcon from './MinusIcon.vue'
import ArrowLeftIcon from './ArrowLeftIcon.vue'
import SaveIcon from './SaveIcon.vue'
import SubmitButton from './SubmitButton.vue'
import SelectInput from './SelectInput.vue'
import Api from './../api'
import flash from './../Flash'
import { origins } from './../helpers'

export default {
  props: {
    id: {type: [String, Number], required: true}
  },
  components: {
    FormGroup,
    TextInput,
    CheckboxInput,
    QuestionButton,
    TrashIcon,
    PlusIcon,
    MinusIcon,
    ArrowLeftIcon,
    CurrencyInput,
    SaveIcon,
    SubmitButton,
    SelectInput,
    Api
  },
  data () {
    return {
      originOptions: origins,
      submitting: false,
      focusedDraftPrice: null,
      record: {
        card: {
          slug: ''
        },
        product: {
          enabled: false,
          name: '',
          origin: '',
          unit: '',
          variety: ''
        },
        publicPrices: [],
        draftPrices: [],
        previousPrices: []
      },
      errors: []
    }
  },
  methods: {
    submit () {
      this.errors = []
      this.submitting = true
      this.record.draftPrices = this.record.draftPrices.filter(p => p.price > 0)
      Api.record.update(this.id, this.record).then(this.updateSuccess, this.updateError).then(() => { this.submitting = false })
    },
    updateSuccess ({body}) {
      this.record = body
      flash.success('Zapisano zmiany poprawnie')
    },
    archiveProductSuccess ({body}) {
      this.record.product = body
      flash.success('Produkt zarchiwizowano poprawnie')
    },
    unArchiveProductSuccess ({body}) {
      this.record.product = body
      flash.success('Produkt przywrócono poprawnie')
    },
    updateError ({body}) {
      const violations = body.violations
      violations.forEach(violation => {
        this.errors[violation.propertyPath] = violation.message
      })
    },
    fetchData () {
      Api.record.get(this.id, this.fetchSuccess)
    },
    fetchSuccess ({body}) {
      this.record = body
    },
    archiveProduct (product) {
      Api.product.archive(product.id).then(this.archiveProductSuccess)
    },
    unArchiveProduct (product) {
      Api.product.unArchive(product.id).then(this.unArchiveProductSuccess)
    },
    addDraftPrice () {
      this.record.draftPrices.push({
        price: '0.00'
      })
    },
    removeDraftPrice (index) {
      this.record.draftPrices.splice(index, 1)
    },
    usePreviousPrices () {
      this.record.draftPrices = this.record.previousPrices.map(o => Object.assign({}, o))
    },
    removeFocusedDraftPrice () {
      if (this.focusedDraftPrice) {
        this.removeDraftPrice(this.focusedDraftPrice)
      }
    },
    updateFocusedDraftPrice (index) {
      this.focusedDraftPrice = index
    },
    focusPreviousDraftPrice () {
      if (this.focusedDraftPrice && this.focusedDraftPrice > 0) {
        this.focusedDraftPrice--
      }
    },
    focusNextDraftPrice () {
      if (this.focusedDraftPrice && this.record.draftPrices.length > this.focusedDraftPrice) {
        this.focusedDraftPrice++
      }
    },
    isDraftPriceFocused (index) {
      return this.focusedDraftPrice === index
    }
  },
  computed: {
    emptyPreviousPrices () {
      return this.record.previousPrices.length === 0
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// RecordEdit.vue?e7e4a7ba